var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as moment from 'moment';
import { NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
var DatePickerFormatter = /** @class */ (function (_super) {
    __extends(DatePickerFormatter, _super);
    function DatePickerFormatter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DatePickerFormatter.prototype.parse = function (value) {
        if (value && (10 === value.length)) {
            var date = moment(value, 'MM/DD/YYYY');
            return new NgbDate(date.year(), date.month() + 1, date.date());
        }
        return null;
    };
    DatePickerFormatter.prototype.format = function (date) {
        if (date) {
            return moment({ year: date.year, month: date.month - 1, day: date.day }).format('MM/DD/YYYY');
        }
        return null;
    };
    return DatePickerFormatter;
}(NgbDateParserFormatter));
export { DatePickerFormatter };
